module.exports = __webpack_public_path__ + "static/media/wizualizacja-28.6d260464.png";